import {SET_SORT_STATE_EDITABLE_TABLE} from "../types";

export function setSortStateEditableTable(data) {
    return {
        type: SET_SORT_STATE_EDITABLE_TABLE,
        data: data,
    };
}